import React, {useState, useRef} from 'react';
import {message, Modal, Row} from 'antd';
import './style.module.css';
import ButtonComponent from '../../../atoms/Buttons';
import GeneralModal, {GeneralModalRef} from '../../../molecules/Modals/general/component';
import authService from '../../../../services/authService';
import SetEmailForm from '../../../molecules/Forms/SetEmail/component';
import {validateEmail} from '../../../../utils/validators';

type FormProps = {
    visible: boolean;
    onClose: () => void;
    title?: string
    reqEmail?: string
};

const SetEmailDialog = ({visible, onClose, title, reqEmail}: FormProps) => {
    const generalModalRef = useRef<GeneralModalRef>(null);
    const [email, setEmail] = useState('');
    const [required, setRequired] = useState(false);
    const [emailValid, setEmailValid] = useState(true);
    const [sameEmail, setSameEmail] = useState(true);

    const handleOk = async (event: React.FormEvent) => {
        event.preventDefault();
    };

    const handleCancel = async () => {
        onClose();
    };

    const handleEmailChange = (email: string) => {
        setEmail(email);
        setEmailValid(validateEmail(email));
        console.log(email, reqEmail);
        setSameEmail(email === reqEmail);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            setRequired(true);
            if (email && emailValid && sameEmail) {
                const result: any = await authService.regenerateVerificationLink({email: email});
                if (result?.status === 200) {
                    console.log(result);
                    message.info(result?.data?.message);
                }
            }
        } catch (error: any) {
            message.error(error?.response?.message);
        }
    };

    return (
        <Modal open={visible} onCancel={handleCancel} onOk={handleOk} centered maskClosable={false} width={700}
               footer={[
                   <ButtonComponent key={'cancel-button'} onClick={handleCancel} label={'Cancel'} buttonType={'default'}
                                    className={'cancel'}/>,

                   <ButtonComponent key={'create-button'} onClick={handleSubmit} label={'Set email'}
                                    buttonType={'default'}
                                    className={'save'}/>
               ]}
               className={'customModal'}
        >
            <Row>
                <SetEmailForm email={email} required={required} onEmailChange={handleEmailChange} title={title}
                              sameEmail={sameEmail} emailValid={emailValid}/>
            </Row>
            <GeneralModal ref={generalModalRef}/>
        </Modal>
    );
};

export default SetEmailDialog;